import React, { ReactNode, useEffect, useState } from "react";
import { Box, Flex, SystemProps, Icon, Text } from "@storyofams/react-ui";
import { useMeasure } from "react-use";
import { Minus, Plus } from "~components/common/Icons";

interface AccordionProps extends SystemProps {
  title: string;
  children: ReactNode | string;
  close?: boolean;
  open?: boolean;
  withoutLastBorder?: boolean;
}

export const FourColumnTextAccordion = ({
  title,
  children,
  open,
  withoutLastBorder,
  ...props
}: AccordionProps) => {
  const [ref, { height }] = useMeasure();

  return (
    <Box
      borderBottom={!withoutLastBorder ? "1px solid grey200" : "none"}
      mt="-1px"
      textAlign="left"
    >
      <Flex
        justifyContent="space-between"
        alignItems="flex-start"
        /** @ts-ignore this is an indication of whats wrong with the return type of the polymorph */
        py={["16px", "20px"]}
        cursor="pointer"
        px={"20px"}
        {...props}
      >
        <Box position={"relative"}>
          <Text fontSize="20px" fontWeight={[700, 500]} lineHeight={"25.2px"}>
            {title}
          </Text>
        </Box>

        <Flex>
          <Icon icon={open ? Minus : Plus} pt="3px" fontSize={"20px"} />
        </Flex>
      </Flex>
      <Box
        px={"20px"}
        maxHeight={open ? [`${height + 3 * 8}px`, `${height + 4 * 8}px`] : 0}
        transition="max-height ease 0.3s"
        overflow="hidden"
      >
        <Box
          onClick={(e) => e.stopPropagation()}
          pb={["12px", "20px"]}
          transition="opacity ease 0.25s"
          opacity={open ? 1 : 0}
          ref={ref}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
